import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51e01cef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Rate Add", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Miles" }, "Miles", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Km" }, "Kilometers", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Distance Type", -1))
const _hoisted_8 = { class: "form-floating" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Per Unit Price", -1))
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Base Price", -1))
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Base Unit", -1))
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Base Rate ", -1))
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Reference Rate ", -1))
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Advance Rate ", -1))
const _hoisted_20 = { class: "form-floating" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.distance_type) = $event)),
          class: "form-control",
          required: ""
        }, _hoisted_6, 512), [
          [_vModelSelect, $setup.data.distance_type]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.per_unit_price) = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Per Unit Price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.per_unit_price]
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.base_price) = $event)),
          class: "form-control",
          placeholder: "Base Price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.base_price]
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.base_unit) = $event)),
          class: "form-control",
          placeholder: "Base Unit",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.base_unit]
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.is_base_rate) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_base_rate]
        ]),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.is_reference_rate) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_reference_rate]
        ]),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.is_advance_rate) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_advance_rate]
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.city_id) = $event)),
          class: "form-control"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
            return (_openBlock(), _createElementBlock("option", {
              key: city.id,
              value: city.id
            }, _toDisplayString(city.name), 9, _hoisted_21))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.city_id]
        ]),
        _hoisted_22
      ]),
      _hoisted_23
    ], 32)
  ]))
}